import { Component, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { Filter } from "@merchant_app/storage/transactions/transactions.state";
import { CardBrandEnum } from "@merchant_api/models/card-brand-enum";
import { TransactionStatus } from "@merchant_api/models/transaction-status";
import { LocalTimePoint } from "shared-lib";
import { GatewayEnum } from "@merchant_api/models/gateway-enum";
import { DigitalWalletEnum } from "@merchant_api/models/digital-wallet-enum";
import { TransactionType } from "@merchant_api/models/transaction-type";

@Component({
    selector: "app-transaction-log-filters",
    templateUrl: "./transaction-log-filters.component.html",
    styleUrls: ["./transaction-log-filters.component.less"],
    standalone: false
})
export class TransactionLogFiltersComponent {

    @Output() filterChanged = new EventEmitter<Filter>();

    @Input() filter: Filter;

    gatewayList: Array<GatewayEnum>;
    typeList: Array<TransactionType>;
    digitalWalletList: Array<DigitalWalletEnum>;
    serviceFeeList: Array<string>;

    // eslint-disable-next-line max-len
    readonly moreFields = ["cardBrands", "transactionId", "authCode", "gateways", "tid", "localDateSettledInterval", "mid", "digitalWallets", "isServiceFee", "token"];

    LocalTimePoint = LocalTimePoint;

    constructor(
        private fb: UntypedFormBuilder
    ) {
        this.gatewayList = Object.values(GatewayEnum);
        this.typeList = Object.values(TransactionType).sort();
        this.digitalWalletList = Object.values(DigitalWalletEnum);
        this.serviceFeeList = [
            "No",
            "Yes"
        ];
    }

    amountMask = {
        mask: Number,
        scale: 2,
        thousandsSeparator: ",",
        padFractionalZeros: true,
        radix: ".",
        mapToRadix: [","]
    };

    filterForm = this.fb.group({
        localDateInterval: [null],
        localDateSettledInterval: [null],
        transactionId: [null],
        amount: [null],
        authCode: [null],
        first6: [null, [Validators.pattern(/^\d{6}$/)]],
        last4: [null, [Validators.pattern(/^\d{4}$/)]],
        payerName: [null, [Validators.pattern(/^[a-zA-Z0-9\s]+$/)]],
        cardBrands: [null],
        types: [null],
        statuses: [null],
        gateways: [null],
        tid: [null],
        mid: [null],
        digitalWallets: [null],
        isServiceFee: [null],
        token: [null]
    });

    cardList = [
        CardBrandEnum.Amex,
        CardBrandEnum.Discover,
        CardBrandEnum.MasterCard,
        CardBrandEnum.Visa,
    ];

    statusList = Object.values(TransactionStatus);

    onFilterChanged(filter: any) {

        this.filterChanged.emit(filter);
    }

}
